import React from 'react';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import FilterModel from 'app/components/FilterModel';
import Dropdown from 'app/components/Dropdown';
import { storeTableHeader } from 'app/constants/table-header-constants';
import useStoreMangement from './useStoreMangement';

const STATUS_OPTIONS = [
  { label: 'Active', value: 'true' },
  { label: 'Inactive', value: 'false' },
];

const CDIT_OPTIONS = [
  { label: 'Under CDIT', value: 'true' },
  { label: 'Not Under CDIT', value: 'false' },
];

const StoreMangement = () => {
  const {
    isdeleteFiltering,
    handleDelete,
    handleEdit,
    handleNew,
    pageLoading,
    currentPage,
    dataPerPage,
    pageCount,
    totalNumber,
    filteredData,
    sectionObj,
    fetchStoreData,
    isFilterOpen,
    setIsFilterOpen,
    isFiltering,
    values,
    setValues,
    appliedFilters,
    handleSubmit,
    handleFilterCancel,
    resetfilter,
  } = useStoreMangement();

  return (
    <>
      <div className='cms-content__container'>
        <PaginatedTable
          sectionObj={sectionObj}
          columns={storeTableHeader}
          data={filteredData}
          fulldata={filteredData}
          currentPage={currentPage}
          dataPerPage={dataPerPage}
          totalNumber={totalNumber}
          pageCount={pageCount}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          handleNew={handleNew}
          pageLoading={pageLoading}
          fetchData={fetchStoreData}
          isdeleteFiltering={isdeleteFiltering}
          isFiltering={isFiltering}
          values={appliedFilters}
        />

        {isFilterOpen && (
          <FilterModel
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            onSubmit={handleSubmit}
            onCancel={handleFilterCancel}
            values={values}
            setValues={setValues}
            resetfilter={resetfilter}
          >
            <div className='offcanvas-item'>
              <Dropdown
                id='status'
                label='Status'
                name='status'
                options={STATUS_OPTIONS}
                placeholder='All'
                value={values.status}
                handleChange={(e) =>
                  setValues({ ...values, status: e.target.value })
                }
              />
            </div>
            <div className='offcanvas-item'>
              <Dropdown
                id='isCdit'
                label='CDIT'
                name='isCdit'
                options={CDIT_OPTIONS}
                placeholder='All'
                value={values.isCdit}
                handleChange={(e) =>
                  setValues({ ...values, isCdit: e.target.value })
                }
              />
            </div>
          </FilterModel>
        )}
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default StoreMangement;
